import countries from "constants/countries";
import IProduct from "../../../../models/product";
import ListDropDown from "../../../inputfields/ListDropDown";
import DetailedInputLabel from '../../../inputfields/InputLabel';
import { IFoodlaCategoryOption } from "models/category";
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';
import { useProductValidations } from '../validation-context/ProductValidationContext';

interface ICountryOfOriginProps {
  readOnly?: boolean;
  approve: boolean;
  state: IProduct;
  setState: (state: Partial<IProduct>) => void;
  rootCategory?: IFoodlaCategoryOption;
}

export const data = countries
.sort((a, b) => {
  if (a.start) {
    return -1;
  }
  if (!a.start && b.start) {
    return 1;
  }
  return ('' + a.sv).localeCompare(b.sv);
})
.map((c) => ({
  value: c.code,
  displayName: c.sv,
  iso2: c.iso2,
}));

export const CountryOfManufacturing = ({ readOnly, approve, state, setState, rootCategory }: ICountryOfOriginProps) => {
  const { requiredFields } = useProductValidations();
  const handleChange = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    const stateName = event.target.name;
    let stateValue = event.target.value;

    console.log(`NAME: ${stateName} - VALUE: ${stateValue}`);
    const val = !stateValue || stateValue === '' ? null : stateValue;
    stateName && setState({ ...state, [stateName]: val });
  };
  return (
    <>
      <DetailedInputLabel
        id="country_of_manufacturing"
        heading="Tillverkningsland"
        required={!!requiredFields.country_of_manufacturing}
        text="Artikelns tillverkningsland är det land där den genomgick den sista väsentliga bearbetningen."
        // link={
        // 'https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:02008R1333-20191028&qid=1583398059728&from=SV'
        // }
      />
      <div style={{ display: 'flex', flex: 1 }}>
        <ListDropDown
          readOnly={readOnly}
          // label="Tillverkningsland"
          showSearch
          listData={data}
          value={state.country_of_manufacturing}
          targetName="country_of_manufacturing"
          handleChange={handleChange}
          disabled={state?.isMagazine}
          displayEmpty={true}
          style={{ flexGrow: 1, overflow: 'hidden' }}
        />
        {approve && state?.approve?.find(x => x.field === 'country_of_manufacturing') && (
          <ThreeWaySwitch
            readOnly={readOnly}
            state={state}
            style={{ height: 56 }}
            setState={setState}
            name="country_of_manufacturing"
          />
        )}
      </div>
    </>
  );
};

export default CountryOfManufacturing;
